function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { Fragment, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import path from 'path';
import { Empty } from '@signicat/designi/components/containers';
import { Row } from '@signicat/designi/components/layout';
import { Button } from '@signicat/designi/components/buttons';
import Filters from "../components/Filters";
import SignOrdersList from "../components/SignOrdersList";
import { orders as ordersActions } from "../store/actions";
import { t } from "../helpers/i18n";
import ReadOnlyBanner from "../components/ReadOnlyBanner";
var ListContainer = styled('div').withConfig({
  displayName: "Root__ListContainer",
  componentId: "sc-1efmhaa-0"
})(["display:", ";"], function (props) {
  props.isLoading ? 'none' : 'auto';
});

//eslint-disable-next-line
export default (function (props) {
  var _useSelector = useSelector(function (state) {
      return state.module.settings;
    }),
    signature = _useSelector.signature;
  var dispatch = useDispatch();
  var history = useHistory();
  var signOrders = useSelector(function (state) {
    return state.orders;
  });
  var _useState = useState([{
      id: 'all',
      searchTerm: ''
    }]),
    _useState2 = _slicedToArray(_useState, 2),
    filters = _useState2[0],
    setFilters = _useState2[1];
  var _useState3 = useState(signature),
    _useState4 = _slicedToArray(_useState3, 2),
    settings = _useState4[0],
    setSettings = _useState4[1];
  var readonlyPortal = settings === null || settings === void 0 ? void 0 : settings.readOnly;
  useEffect(function () {
    dispatch(ordersActions.getList(0, filters[0], {
      field: 'created',
      desc: true
    }));
  }, []);
  useEffect(function () {
    setSettings(signature);
  }, [signature]);
  var match = props.match;
  var basename = match.path;
  if (signOrders.isLoading === false && signOrders.error) {
    return /*#__PURE__*/React.createElement(Empty, {
      emoji: "\uD83D\uDC1E",
      heading: t('orders_error_heading_could_not_get'),
      message: t('orders_error_message_could_not_get'),
      action: t('button_text_try_again'),
      handleActionClick: function handleActionClick() {
        dispatch(ordersActions.getList(signOrders.offset, signOrders.filter, signOrders.orderBy));
      }
    });
  }
  if (signOrders.isLoading === false && signOrders.isEmpty) {
    return /*#__PURE__*/React.createElement(Empty, {
      emoji: "\u2728",
      heading: t('orders_noorders_heading'),
      message: t('orders_noorders_message'),
      action: t('orders_noorders_action'),
      handleActionClick: function handleActionClick() {
        history.push('/signature/create');
      }
    });
  }
  return /*#__PURE__*/React.createElement(Fragment, null, readonlyPortal ? /*#__PURE__*/React.createElement(ReadOnlyBanner, null) : null, /*#__PURE__*/React.createElement(ListContainer, {
    isLoading: signOrders.isLoading
  }, /*#__PURE__*/React.createElement(Row, {
    horizontal: "end"
  }, /*#__PURE__*/React.createElement("div", {
    title: readonlyPortal ? t("read_only_mode_text") : ""
  }, /*#__PURE__*/React.createElement(Button, {
    id: "create-signing-order",
    icon: "create",
    color: "primary",
    disabled: readonlyPortal,
    forwardedAs: Link,
    to: path.join(basename, 'create'),
    style: {
      pointerEvents: readonlyPortal ? "none" : "initial"
    }
  }, t('button_text_new_signing_order')))), /*#__PURE__*/React.createElement(Filters, {
    setFilters: setFilters
  }), /*#__PURE__*/React.createElement(SignOrdersList, {
    filters: filters
  })));
});